const brandZh = {
  brand: {
    添加品牌WhatsApp了解最新优惠:
      '添加品牌<img src="https://ricepon.oss-cn-hongkong.aliyuncs.com//h5/172620942457196c293beRicepon.png" />WhatsApp，了解最新优惠',
    前往添加: "前往添加",
    更换地址: "更换地址",
    自取: "自取",
    外送: "外送",
    会员二维码: "会员二维码",
    优惠券: "优惠券({X})",
    邀请有礼: "邀请有礼",
    积分换礼: "积分换礼",
    此等级需购买: "此等级需购买",
    会员卡说明: "会员卡说明",
    当前等级: "当前等级",
    立即购买XY: "立即购买 {X}({Y})",
    查看等级特权: "查看等级特权",
    暂不支持购买: "暂不支持购买!",
    查看更多: "查看更多",
    折扣优惠: "折扣优惠",
    零售价: "零售价",
    团购促销: "团购促销",
    人气王: "人气王",
    回头客X: "回头客 {X}",
    半年售X: "半年售 {X}",
    团购详情: "团购详情",
    购买须知: "购买须知",
    立即抢购: "立即抢购",
    请选择数量: "请选择数量",
    免预约: "免预约",
    周一到周日可用: "周一到周日可用",
    支付方式: "支付方式",
    商品总价: "商品总价",
    优惠共减: "优惠共减",
    提交订单: "提交订单",
    X人餐: "{X}人餐",
    提交成功: "提交成功!",
    品牌门店: "品牌门店",
    壽司海鮮: "壽司/海鮮",
    人均X: "{X}/人均",
    查看更多店铺X: "查看更多店铺({X})",
    分享至: "分享至",
    取消: "取消",
    Facebook: "Facebook",
    Instagram: "Instagram",
    WhatsApp: "WhatsApp",
    复制链接: "复制链接",
    链接已复制: "链接已复制",
    复制失败: "复制失败",
    累计售X: "累计售 {X}",
    抢购: "抢购",
    AI评分描述: "评分由AI通过参考第三方平台对此餐厅的评分进行综合计算，饭团Ricepon不对此结果负责，请食客仔细甄选~",
    餐厅类型X: "{X}",
    人均X: "{X}/人均",
    营业时间: "营业时间",
    距您Xm: "距您{X}",
    导航: "导航",
    电话: "电话",
    外送: "外送",
    自取: "自取",
    标签X: "标签 {X}",
    团购标题: "# 团购",
    餐厅简介: "餐厅简介",
    营业中: "营业中",
    休息中: "休息中",
    繁忙中: "繁忙中",
    服务未开启: "服务未开启",
    memberCode: "会员码",
    points: "积分",
    pointsAction: "兑好礼 查明细",
    coupon: "优惠券",
    couponCount: "{X}张",
    viewCollectedCoupons: "查看已领卡券",
    noMore: "没有更多了",
    團購券: "团购券",
    餐飲券: "餐饮券",
    storeAddressPlaceholder: "请输入门店地址",
    opening: "营业中",
    restaurantAddressUnset: "未设定餐厅地址",
    placeOrder: "落单",
    distanceMeter: "距离{X}米",
    chooseStoreByType: "选择{X}门店",
    delivery: "外送",
    pickup: "自取",
    promoZone: "优惠专区",
    platformNotAvailable: "该平台暂未开放",
    soldOut: "售罄",
    onlinePayment: "在线支付",
    noOpenRestaurantOrderTip: "暂无营业中的餐厅!\n请稍后再落单~!",
    invalidPrice: "价格有误,请勿下单!",
  },
};
export default brandZh;
